import { FC } from "react"
import { IconProps } from "@/components/shared/Icon"

const SnoozeAlertIcon: FC<IconProps> = ({ ...props }) => {
   return (
      <svg
         viewBox="0 0 24 24"
         fill="none"
         {...props}
      >
         <path
            d="M1.45519 2.19943C1.06519 1.87913 0.498952 1.95335 0.191457 2.35959C-0.116037 2.76583 -0.0447884 3.35566 0.345205 3.67596L22.5448 21.8006C22.9348 22.1209 23.501 22.0467 23.8085 21.6404C24.116 21.2342 24.0448 20.6443 23.6548 20.324L20.3474 17.6249C20.4486 17.3202 20.3961 16.9804 20.2011 16.7265L19.6424 15.9999C18.5811 14.6132 17.9999 12.8906 17.9999 11.1172V9.81255C17.9999 6.85168 15.9187 4.3986 13.2 3.9494V3.25019C13.2 2.5588 12.6637 2.00022 12 2.00022C11.3363 2.00022 10.8 2.5588 10.8 3.25019V3.9494C9.1538 4.22283 7.74382 5.22671 6.88509 6.63293L1.45519 2.19943ZM8.31381 7.79697C8.98505 6.57434 10.2488 5.75014 11.7 5.75014H12H12.3C14.4525 5.75014 16.1999 7.57041 16.1999 9.81255V11.1172C16.1999 12.3945 16.4399 13.6484 16.9012 14.8085L8.31381 7.79697ZM6.00011 11.1172C6.00011 12.8906 5.41887 14.6132 4.35763 15.996L3.79889 16.7265C3.5814 17.0077 3.54015 17.3944 3.69015 17.7186C3.84014 18.0428 4.15514 18.2499 4.50013 18.2499H15.2324L12.9487 16.3749H6.31135C7.10634 15.0937 7.60133 13.6289 7.75132 12.1133L6.00011 10.6758V11.1211V11.1172ZM14.4 19.4998H12H9.60004C9.60004 20.1639 9.85129 20.8006 10.3013 21.2693C10.7513 21.7381 11.3625 21.9998 12 21.9998C12.6375 21.9998 13.2487 21.7381 13.6987 21.2693C14.1487 20.8006 14.4 20.1639 14.4 19.4998Z"
            fill="currentColor"
         />
      </svg>
   )
}

export default SnoozeAlertIcon
